<div class="container-fluid bg-black pt-5 text-white">
  <div class="row">
    <div class="col-md-12 d-flex flex-column align-items-center mt-2 mb-5">
      <p
        class="fw-bold fs-1 lh-lg text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        [attr.data-aos-delay]="500"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{ "Codesroots can help you achieve your business goals" | translate }}
      </p>
      <p
        class="fs-6 text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        [attr.data-aos-delay]="1000"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{
          "Codesroots apps are your most important medium of interest. We provide you with a budget that will be in your hands."
            | translate
        }}
      </p>
    </div>
    <div
      class="col-md-6 d-flex gap-3 flex-column align-items-center py-5 px-5 text-center mt-2 gap-5"
      *ngFor="let work of works; let i = index"
    >
      <img
        [src]="work.photo"
        class="app-img"
        alt=""
        data-aos="fade-up"
        data-aos-duration="1000"
        [attr.data-aos-delay]="500"
        data-aos-offset="50"
        data-aos-once="true"
      />
      <p
        class="fs-3 fw-bold m-0"
        data-aos="fade-up"
        data-aos-duration="1000"
        [attr.data-aos-delay]="1000"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{ work.title | translate }}
      </p>
      <p
        class="lh-lg m-0"
        data-aos="fade-up"
        data-aos-duration="1000"
        [attr.data-aos-delay]="1500"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{ lang == "en" ? work.description : work.description_ar }}
      </p>
    </div>
    <div class="col-md-12 p-0">
      <svg
        width="100%"
        viewBox="0 0 1600 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="sdsm-break-skirt css-1rvezcx"
        preserveAspectRatio="none"
      >
        <rect x="0" y="3" width="1600" height="150" fill="#FFFFFF"></rect>
        <g clip-path="url(#break_clip0)">
          <mask
            id="break_mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="-494"
            y="-251"
            width="3069"
            height="367"
          >
            <path
              d="M-491.078 -31.1967C-504.37 -8.63441 -452.609 7.88091 -402.184 14.8797C-319.521 26.74 -221.284 29.2152 -164.431 30.337C-148.841 30.6792 -134.283 30.9787 -121.236 31.3862C-107.092 31.7301 -93.9083 33.3325 -82.9028 36.0451C-72.3929 40.5936 -65.3952 46.0742 -62.4544 52.0602C-58.2308 58.6759 -50.1045 64.7505 -38.5526 69.9272C-27.0006 75.104 -12.256 79.2784 4.81557 82.2056C51.5574 89.5258 108.038 86.4799 179.925 82.1C272.993 75.5399 366.507 73.7256 457.425 76.7162C510.273 79.7304 561.104 84.9338 608.901 92.2223C721.78 107.457 862.476 126.006 1092.44 109.572C1322.41 93.1377 1451.89 54.7577 1556.04 24.0128C1598.79 10.3649 1645.33 -1.70017 1694.73 -11.9381C1781.55 -27.7193 1873.01 -39.1262 1966.03 -45.7728C2037.23 -51.7929 2093.51 -56.5724 2135.77 -70.3698C2152.03 -75.9867 2165.18 -82.5726 2174.38 -89.7088C2183.58 -96.8451 2188.64 -104.376 2189.23 -111.822C2189.32 -117.234 2193.24 -122.735 2200.67 -127.844C2209.9 -131.879 2221.55 -135.192 2234.6 -137.493C2247.4 -139.864 2261.74 -142.228 2277.55 -144.872C2349.88 -155.948 2418.75 -170.3 2482.17 -187.516C2580.19 -214.211 2582.08 -239.104 2568.76 -250.444"
              fill="#1C1C1C"
            ></path>
          </mask>
          <g mask="url(#break_mask0)">
            <rect width="1600" height="150" fill="black"></rect>
          </g>
        </g>
        <defs>
          <clipPath id="break_clip0">
            <path d="M0 0H1600V150H0V0Z" fill="#000000"></path>
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</div>
